import axios from "axios";
import appConfig from "./appConfig";

const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

// עד 3 ניסיונות עם השהיה קצרה - עומס רגעי על מכסת Google Sheets API (בזמן רישום
// עם הרבה הורים בו-זמנית) לא אמור לגרום לכך שהשיבוץ בזוהו נוצר אבל "האם נרשם"
// בגיליון נשאר ריק.
const markRegisteredInSheet = async (idNumber: any, schedulingId: string) => {
  for (let attempt = 1; attempt <= 3; attempt++) {
    try {
      await axios.post(`${appConfig.apiUrls.baseUrl}/sheets/mark-registered/${idNumber}`, { schedulingId });
      return;
    } catch (err) {
      console.error(`שגיאה בעדכון סטטוס רישום בגיליון (ניסיון ${attempt}/3):`, err);
      if (attempt < 3) await sleep(attempt * 1500);
    }
  }
};

export const getOrCreateSchedulingId = async (
  serverData: any, idNumber: any, email: any, selectedStation: any, method: any,
  options?: { throwOnDuplicate?: boolean; yearOverride?: string; phone?: string; street?: string; houseNumber?: string; city?: string }
): Promise<string | null> => {
  try {

    const currentYear = options?.yearOverride || appConfig.year;

    // שלב 1: בדיקת קיום איש קשר / יצירתו - כל זה קורה בצד השרת (כולל שליפת פרטי
    // ההורים מהגיליון והעשרת איש הקשר בזוהו איתם), כדי שפרטי הורים לא יעברו דרך
    // הדפדפן בכלל.
    console.log("Checking or creating student with ID:", idNumber);
    const contactRes = await axios.post(
      `${appConfig.apiUrls.baseUrl}/zohoStudents/getOrCreateContact/${idNumber}`,
      {
        fallbackName: serverData.name, email, phone: options?.phone,
        street: options?.street, houseNumber: options?.houseNumber, city: options?.city,
      }
    );
    const studentId: string = contactRes.data.contactId;

    console.log("studentId:", studentId);

    // שלב 2: בדיקת שיבוץ קיים
    const schedRes = await axios.get(`${appConfig.apiUrls.baseUrl}/zohoStudents/schedulingById/${idNumber}/${currentYear}`);
    console.log("schedRes", schedRes.data.data)
    const schedulingList = schedRes.data.data;

    if (Array.isArray(schedulingList) && schedulingList.length > 0) {
      const existing = schedulingList[0];
      // יש חוב רק אם debt > 0, למעט: הוראת קבע פעילה, או תלמיד זכאי (רשום) - שני
      // המקרים האלה נחשבים כאילו אין חוב. Payreceived אינו שדה אמין - הוורקפלואו
      // של "חשב סכומים" לא מעדכן אותו.
      const noDebt = Number(existing.debt) <= 0 || existing.DirectDebit === "הוראת קבע פעילה" || existing.field37 === "זכאי";

      // Allow continuing (reusing the existing scheduling) only when the student
      // actually still owes money — otherwise this is a duplicate registration
      // attempt and must be blocked.
      if (noDebt || method === "noPayment") {
        const msg = `תלמיד זה כבר רשום לתקופה ${currentYear}. לבירורים יש לפנות לשירות הלקוחות.`;
        if (options?.throwOnDuplicate) throw new Error('DUPLICATE_SCHEDULING: ' + msg);
        alert(msg);
        return null;
      } else {
        console.log("נמצא שיבוץ ללא תשלום - ממשיכים עם מזהה קיים");
        await markRegisteredInSheet(idNumber, existing.id);
        return existing.id; // מחזיר את מזהה השיבוץ הקיים
      }
    } else {
      console.log("לא קיים שיבוץ לתלמיד - ממשיכים ליצירת שיבוץ");
    }


    // שלב 3: יצירת שיבוץ חדש
    const schedulingData = {
      data: [
        {
          account: appConfig.accounts.lodBuses.accountId,
          mosad: appConfig.accounts.lodBuses.mosadId,
          Name: `הסעות ${serverData.name} ${currentYear}`,
          id_child: idNumber,
          field2: currentYear.toString(),
          contactid: studentId,
          // סטודנט שאינו זכאי וצריך לשלם מתחיל "לא פעיל" - הסטטוס יתעדכן אוטומטית
          // כשהתשלום הראשון נקלט ו"חשב סכומים" מופעל (finalizePayment בשרת).
          status: serverData.eligible === 'זכאי' ? "פעיל- יש חוב" : "לא פעיל",
          Modified_Time: getCurrentDateTimeString(),
          field35: serverData.institution,
          field36: selectedStation,
          field37: serverData.eligible,
          Annual_charge: serverData.price,
          Layout: {
            display_label: "הסעות",
            name: "הסעות",
            id: "5154700000058279001"
          },
        }
      ],
         trigger: ['workflow', 'blueprint'] // זה מחוץ ל-data
    };

     console.log("Scheduling Data to be sent:", JSON.stringify(schedulingData, null, 2));

     const newSchedRes = await axios.post(`${appConfig.apiUrls.baseUrl}/zohoStudents/addScheduling`, schedulingData);
     const newSchedulingId = newSchedRes.data?.data?.[0]?.details?.id;
     if (newSchedulingId) await markRegisteredInSheet(idNumber, newSchedulingId);
    return newSchedulingId;
  } catch (err) {
    console.error("שגיאה בבדיקת/יצירת תלמיד ושיבוץ:", err);
    alert("אירעה שגיאה בעת ניסיון לרשום את הילד. אנא פנה לתמיכה.");
    return null;
  }
};

const getCurrentDateTimeString = () => {
  const now = new Date();
  const offset = now.getTimezoneOffset() * -1;
  const offsetHours = Math.floor(offset / 60);
  const offsetMinutes = offset % 60;
  const offsetSign = offset >= 0 ? "+" : "-";
  const formattedOffset = `${offsetSign}${String(offsetHours).padStart(2, "0")}:${String(offsetMinutes).padStart(2, "0")}`;
  return now.toISOString().replace("Z", formattedOffset);
};
